import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    events: [],
    blogs: []
  },
  mutations: {
    setEvents(state, events) {
      state.events = events
    },
    setBlogs(state, blogs) {
      state.blogs = blogs
    }
  },
  actions: {
    async fetchEvents({ commit }) {
      try {
        // In a real app, this would be an API call
        const events = [
          {
            id: 1,
            title: 'IELTS Vocabulary Class',
            description: 'Focus on academic vocabulary for IELTS writing',
            date: new Date(2025, 3, 15),
            time: '10:00 AM'
          },
          {
            id: 2,
            title: 'Speaking Practice',
            description: 'One-on-one speaking practice session',
            date: new Date(2025, 4, 18),
            time: '2:00 PM'
          },
          {
            id: 3,
            title: 'Legal English Workshop',
            description: 'Specialized terminology for legal professionals',
            date: new Date(2025, 3, 22),
            time: '3:30 PM'
          }
        ];
        commit('setEvents', events);
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    },
    async fetchBlogs({ commit }) {
      try {
        // In a real app, this would be an API call
        const blogs = [
          {
            id: 1,
            title: 'IELTS Writing: How to Structure Your Essay',
            image: require('../assets/images/blog1.jpg'),
            date: 'November 10, 2023',
            category: 'IELTS',
            excerpt: 'Learn the essential structure for IELTS writing task 2 essays to maximize your score potential.'
          },
          // ... other blog entries
        ];
        commit('setBlogs', blogs);
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }
    }
  },
  modules: {
  }
})